<script lang="ts">
  // Unified transit route badge rendering circles for local services and diamonds for express ("X") routes.
  import { getRouteColor, routeBadgeLabel } from '../ui/colors'
  import { bulletFontPx, bulletText } from '../ui/theme'

  interface Props {
    routeId: string
    size?: number
    style?: string
    class?: string
  }

  const { routeId, size = 28, style = '', class: className = '' }: Props = $props()

  const isExpress = $derived(routeId.includes('X'))
  const label = $derived(routeBadgeLabel(routeId))

  const fontSize = $derived(
    bulletFontPx(
      label,
      size,
      label.length > 2 ? size * 0.34 : size * 0.44,
      isExpress ? 'diamond' : 'circle',
    ),
  )
</script>

<div
  class={className}
  style="
    width: {size}px; height: {size}px; background-color: {getRouteColor(routeId)};
    {isExpress
      ? 'clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);'
      : `border-radius: ${size / 2}px;`}
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
    {style}
  "
>
  <span style="{bulletText(routeId, fontSize)};">
    {label}
  </span>
</div>
